import React, { Component, createRef } from 'react';
import QuizDraw from './QuizDraw';
import Sound from '../UI/Sound';
import { TYPES } from '../../constants/activityTypes';
import withActivityAnalytics from '../../hoc/WithActivityAnalytics';
import axios from 'config/axios';

class QuizDrawResponse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tries: 0,
            skip: true,
            isSubmitting: false,
            confirmClearing: false,
            activityId: props.activityId,
        };

        this._quizDraw = createRef();

        this.onTextAreaChange = this.onTextAreaChange.bind(this);
        this.handleDone = this.handleDone.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onDrawAction = this.onDrawAction.bind(this);
        this.handleClearDrawing = this.handleClearDrawing.bind(this);
        this.confirmClear = this.confirmClear.bind(this);
    }

    componentDidUpdate(nextP, prevP) {
        if (this.props.activityId !== nextP.activityId) {
            this.handleClearDrawing();
        }
    }

    onTextAreaChange(event) {
        this.setState({ text: event.target.value, tries: 1 });
    }

    onDrawAction() {
        const { tries } = this.state;
        this.setState({ tries: tries + 1 });
    }

    handleClearDrawing() {
        //   const { tries } = this.state;
        this.setState({ tries: 0, confirmClearing: false });
        this._quizDraw.clearSketch();
    }

    confirmClear() {
        this.setState({ confirmClearing: true });

        // this.handleClearDrawing();
    }

    async handleSubmit() {
        const { tries } = this.state;
        if (tries === 0) {
            this.props.dispatchAddAlert('Have a try');
            return false;
        }

        this.props.dispatchAddToScore('brain', 1);
        this.setState({ isSubmitting: true });
        await this.handleDone();
    }

    async handleDone() {
        const { activityId, startTime } = this.props;
        const endTime = this.props.endTime();
        const image = this._quizDraw._sketch.toDataURL('jpeg');

        var result = await axios.post('/api/upload64', {
            activityId: this.props.activityId,
            image: image,
        });

        if (result.data) {
            let drawingUrl = result.data;

            this.setState({
                filename: drawingUrl,
                uploaded: true,
                uploading: false,
            });

            this.props.pushActivityAnalytics(startTime, endTime, TYPES.QUIZ_DRAW_RESPONSE.ID, activityId, {
                correct: 0,
                teacherAssessed: 0,
                drawing: drawingUrl,
            });

            this.props.sendImageFromDraw(drawingUrl);
            this.setState({ isSubmitting: false });

            this.props.activityDone();
        }
    }

    render() {
        const { question, questionImage, questionSound, demoMode, title } = this.props;
        const { isSubmitting, confirmClearing, tries } = this.state;

        return (
            <div className='quiz-wrapper'>
                <div className='quiz-content drawing'>
                    <div className='quiz-question'>
                        <h3>{question ? question : title ? title : ''}</h3>
                        {questionImage && (
                            <div className='quiz-question-img'>
                                <img alt={question ? question : title ? title : ''} src={questionImage} />
                            </div>
                        )}
                        {questionSound && <Sound audioUrl={questionSound} />}
                    </div>
                    <div className={`quiz-textarea quiz-drawing ${confirmClearing ? 'overlay' : ''}`}>
                        <QuizDraw ref={(c) => (this._quizDraw = c)} handleDrawAction={this.onDrawAction} />
                        {confirmClearing && (
                            <div className='alert-confirm-clear'>
                                <p>Are you sure you want to clear the drawing?</p>
                                <p className='confirm-buttons text-center'>
                                    <button className='btn btn-success' onClick={this.handleClearDrawing}>
                                        <i className='fi-check' />
                                    </button>
                                    <button
                                        className='btn btn-danger ml-2'
                                        onClick={() => {
                                            this.setState({
                                                confirmClearing: false,
                                            });
                                        }}
                                    >
                                        <i className='fi-cross' />
                                    </button>
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                {!demoMode && (
                    <div
                        style={{
                            marginBottom: 10,
                            marginTop: 15,
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        {isSubmitting && (
                            <div className='lds-ellipsis'>
                                <div />
                                <div />
                                <div />
                                <div />
                            </div>
                        )}
                        <button
                            className='student-submit-btn'
                            onClick={this.confirmClear}
                            disabled={tries === 0 || (tries > 0 && this.state.isSubmitting)}
                        >
                            CLEAR
                        </button>
                        <button
                            className='student-submit-btn'
                            onClick={this.handleSubmit}
                            disabled={this.state.isSubmitting}
                        >
                            SUBMIT
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default withActivityAnalytics(QuizDrawResponse);
